import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist';
import createIdbStorage from "@piotr-cz/redux-persist-idb-storage";
import userAuthSlice from '../features/user/authSlice'
import systemSlice from '../features/user/systemSlice'
import appDataSlice from '../features/user/appDataSlice'



// Create IndexedDB storage
const storage = createIdbStorage({
    name: 'sales_app',
    storeName: 'v2',
});

const persistConfig = {
    key: 'root',
    storage,
    serialize: false,
    deserialize: false,
};

const rootReducer = combineReducers({

    // user
    userAuth: userAuthSlice,
    systemInfo: systemSlice,
    appData: appDataSlice
});


const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
})

export const persistor = persistStore(store);